const quantityInput = document.querySelectorAll("[data-item-input='quantity']");
if (quantityInput.length) {
  quantityInput.forEach((input) => {
    initQuantityInput(input, modifyCart);
  });
}

const removeInput = document.querySelectorAll("[data-item-input='remove']");
if (removeInput.length) {
  removeInput.forEach((input) => {
    input.addEventListener('click', function (event) {
      event.preventDefault();
      const value = input.dataset.hasOwnProperty('sub') ? getInputResult('sub', parseInt(input.dataset.quantity)) : 0;
      modifyCart(input, value);
    });
  });
}

const currentLocale = window.Shopify.locale + '-' + window.Shopify.country;
const currentCurrency = window.Shopify.currency.active;
const currencyFormatter = new Intl.NumberFormat(currentLocale, {
  style: 'currency',
  currency: currentCurrency,
  currencyDisplay: 'narrowSymbol',
});

async function modifyCart(input, updated) {
  const itemKey = input.dataset.item;
  const lineItems = document.querySelectorAll("[data-line-item='" + itemKey + "']");
  const cartSubtotals = document.querySelectorAll('[data-cart-subtotal]');
  const cartTotals = document.querySelectorAll('[data-cart-total]');
  const cartCounts = document.querySelectorAll('[data-cart-count]');

  if (lineItems.length) lineItems.forEach((lineItem) => lineItem.classList.add('opacity-50'));
  if (cartSubtotals.length) cartSubtotals.forEach((subtotal) => subtotal.classList.add('opacity-50'));
  if (cartTotals.length) cartTotals.forEach((total) => total.classList.add('opacity-50'));

  const cart = await changeCartItem({
    id: itemKey,
    quantity: updated,
  });

  if (lineItems.length) lineItems.forEach((lineItem) => lineItem.classList.remove('opacity-50'));
  if (cartSubtotals.length) cartSubtotals.forEach((subtotal) => subtotal.classList.remove('opacity-50'));
  if (cartTotals.length) cartTotals.forEach((total) => total.classList.remove('opacity-50'));

  if (!cart) return;

  const allCurrencyOutputs = [];
  if (updated == 0) {
    lineItems.forEach((lineItem) => lineItem.parentElement.removeChild(lineItem));
  } else {
    const itemData = cart.items.find((item) => item.key === itemKey);
    if (itemData) {
      lineItems.forEach((lineItem) => {
        const itemTotalPrice = lineItem.querySelector('[data-total-price]');
        if (itemTotalPrice) {
          itemTotalPrice.textContent = currencyFormatter.format(itemData.final_line_price / 100);
          itemTotalPrice.dataset.money = itemData.final_line_price;
          allCurrencyOutputs.push(itemTotalPrice);
        }

        const itemCount = lineItem.querySelector('[data-item-count]');
        const itemSubtract = lineItem.querySelector("[data-item-input='remove'][data-sub]");
        if (itemCount) itemCount.textContent = itemData.quantity;
        if (itemSubtract) itemSubtract.dataset.quantity = itemData.quantity;
      });
    }
  }
  if (cartSubtotals.length) {
    cartSubtotals.forEach((subtotal) => {
      subtotal.textContent = currencyFormatter.format(cart.items_subtotal_price / 100);
      subtotal.dataset.money = cart.items_subtotal_price;
      allCurrencyOutputs.push(subtotal);
    });
  }
  if (cartTotals.length) {
    cartTotals.forEach((total) => {
      total.textContent = currencyFormatter.format(cart.total_price / 100);
      total.dataset.money = cart.total_price;
      allCurrencyOutputs.push(total);
    });
  }
  if (allCurrencyOutputs.length) {
    document.body.dispatchEvent(
      new CustomEvent('CurrencyConverterUpdate', {
        detail: { outputs: allCurrencyOutputs },
      })
    );
  }
  if (cartCounts.length) cartCounts.forEach((count) => (count.textContent = cart.item_count));
  updateFreeShipping(cart);
  if (!cart.item_count) {
    // Add-ons only make sense beside something in the cart (snippets/cart-upsells.liquid renders none for an empty one).
    const cartUpsells = document.querySelectorAll('[data-cart-upsells]');
    if (cartUpsells.length) cartUpsells.forEach((upsells) => upsells.classList.add('hidden'));
    const cartBubbles = document.querySelectorAll('[data-cart-bubble]');
    if (cartBubbles.length) cartBubbles.forEach((bubble) => bubble.parentElement.removeChild(bubble));
    const checkoutButtons = document.querySelectorAll('[data-cart-checkout]');
    if (checkoutButtons.length)
      checkoutButtons.forEach((button) => {
        button.disabled = true;
        button.classList.remove('hover:bg-white/50', 'cursor-pointer');
        button.classList.add('opacity-50');
      });
  }
}

// Free-shipping progress in the cart drawer (snippets/free-shipping-bar.liquid).
function updateFreeShipping(cart) {
  const bars = document.querySelectorAll('[data-free-shipping]');
  bars.forEach((bar) => {
    const threshold = parseInt(bar.dataset.threshold);
    const remaining = Math.max(threshold - cart.total_price, 0);
    // Whole amounts without cents, like Liquid's money_without_trailing_zeros.
    const remainingFormatter = new Intl.NumberFormat(currentLocale, {
      style: 'currency',
      currency: currentCurrency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: remaining % 100 ? 2 : 0,
    });
    bar.classList.toggle('hidden', !cart.item_count);
    bar.querySelector('[data-free-shipping-remaining]').textContent = remainingFormatter.format(remaining / 100);
    bar.querySelector('[data-free-shipping-short]').classList.toggle('hidden', !remaining);
    bar.querySelector('[data-free-shipping-reached]').classList.toggle('hidden', !!remaining);
    bar.querySelector('[data-free-shipping-fill]').style.width = Math.min((cart.total_price / threshold) * 100, 100) + '%';
  });
}

async function changeCartItem(item) {
  const formData = new FormData();
  for (const key in item) {
    if (item.hasOwnProperty(key)) {
      formData.append(key, item[key]);
    }
  }
  const url = window.Shopify.routes.root + 'cart/change.js';

  const promise = await attemptFetch('changing cart item', url, {
    method: 'post',
    body: formData,
  });

  if (!promise) return false;

  const data = await promise.json();

  return data;
}

// Cart drawer add-ons (snippets/cart-upsells.liquid). The first render shows the fallback collection; the first time
// the drawer opens, swap in a render that puts Search & Discovery's complementary products for the newest item first.
const cartDrawerUpsells = document.querySelector('#cart-drawer [data-cart-upsells]');
if (cartDrawerUpsells && cartDrawerUpsells.dataset.productId) {
  const cartDrawer = document.querySelector('#cart-drawer');
  const drawerObserver = new MutationObserver(function () {
    if (cartDrawer.classList.contains('translate-x-full')) return;
    drawerObserver.disconnect();
    loadCartUpsells(cartDrawerUpsells);
  });
  drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
}

async function loadCartUpsells(container) {
  const url =
    window.Shopify.routes.root +
    'recommendations/products?section_id=cart-upsells&intent=complementary&limit=4&product_id=' +
    container.dataset.productId;
  const response = await attemptFetch('loading cart add-ons', url);
  if (!response) return;
  const html = new DOMParser().parseFromString(await response.text(), 'text/html');
  const updated = html.querySelector('[data-cart-upsells]');
  if (!updated || updated.innerHTML.trim() === container.innerHTML.trim()) return;
  container.innerHTML = updated.innerHTML;
  container.querySelectorAll('[data-add_to_cart_drawer]').forEach(handleAddToCartDrawer);
}

const addToCartForms = document.querySelectorAll('[data-add_to_cart_drawer]');
if (addToCartForms) addToCartForms.forEach(handleAddToCartDrawer);

function handleAddToCartDrawer(form) {
  const cartDrawer = document.querySelector('#cart-drawer');
  if (!cartDrawer) return;

  const requestedUrl = new URL(window.location.href);
  if (requestedUrl.hash && requestedUrl.hash === '#added-to-cart') {
    const addonForm = document.querySelector('#addon-to-cart-drawer');
    if (addonForm) addonForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
    $('#cart-drawer').removeClass('translate-x-full');
    $('#cart-drawer-trigger').text('Close').addClass('open');
    requestedUrl.hash = '';
    window.history.replaceState(null, '', requestedUrl.href);
  }

  const returnToUrl = form.querySelector("input[name='return_to']");
  form.addEventListener('submit', function () {
    const currentUrl = new URL(window.location.href);
    currentUrl.hash = 'added-to-cart';
    //returnToUrl.value = currentUrl.pathname + currentUrl.hash + currentUrl.search;
    returnToUrl.value = currentUrl.href.replace(currentUrl.origin, '');
  });
}
